import React from 'react'
import './DisabledContactUpdateSection.scss'

interface DisabledContactUpdateSectionProps {
  title?: string
  subtitle?: string
}

export const DisabledContactUpdateSection: React.FC<DisabledContactUpdateSectionProps> = ({
  title = 'Details are up to date',
  subtitle = 'Other sections are ready to review',
}) => {
  return (
    <div className='details-up-to-date h-100'>
      <div className='icon-container'>
        <i className='bi bi-check-circle' />
      </div>

      <h4 className='title'>{title}</h4>
      <p className='subtitle'>{subtitle}</p>
    </div>
  )
}
